// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__IHv5q","resendInfoText":"OnGoingPaymentBox_resendInfoText__29sia"};